import React, { useEffect, useState } from "react";
import layout from "../../assets/img/becomeanagent/layout.svg";
import layout_bottom_image from "../../assets/img/becomeanagent/layout_bottom_image.svg";
import checkIcon from "../../assets/img/aboutus/check.svg";
import "./FindAnAgents.css";
import AgentGrid from "./AgentCard";

const FindAnAgents = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div
        className="become-agent-bg"
        style={responsiveStatus ? styles.becomeAgentBG_M : styles.becomeAgentBG}
      >
        {/* Decorative shapes */}

        <h3
          className={`${
            responsiveStatus ? "become-agent-partnerM" : "become-agent-partner"
          }`}
        >
          Partner With Us
        </h3>
        <div className="become-agent-underline" />
        <br />
        <h1
          className={`${
            responsiveStatus ? "become-agent-titleM" : "become-agent-title"
          }`}
        >
          Become An Agent
        </h1>
        <p
          className={`${
            responsiveStatus ? "become-agent-descM" : "become-agent-desc"
          }`}
        >
          Welcome to the first step in an exciting and rewarding journey! At
          UAIC, we’re looking for driven, customer-focused <br />
          individuals to join our team of trusted auto insurance agents
        </p>
        <div
          className={`${
            responsiveStatus
              ? "become-agent-benefits-m"
              : "become-agent-benefits"
          }`}
        >
          <span>
            <span className="checkmark">
              <img
                src={checkIcon}
                alt="check"
                style={{ width: "20px", marginRight: "10px" }}
              />
            </span>{" "}
            Career Advancement
          </span>
          <span>
            <span className="checkmark">
              <img
                src={checkIcon}
                alt="check"
                style={{ width: "20px", marginRight: "10px" }}
              />
            </span>{" "}
            Competitive Commissions
          </span>
          <span>
            <span className="checkmark">
              <img
                src={checkIcon}
                alt="check"
                style={{ width: "20px", marginRight: "10px" }}
              />
            </span>{" "}
            Unlimited Earning Potential
          </span>
        </div>
        <img
          src={layout_bottom_image}
          alt="layout"
          className="become-agent-bottom-image"
        />
      </div>
      <dv
        style={{
          backgroundColor: "#d8f4ff",
          display: "inline-block",
          width: "100%",
          // textAlign:"center"
        }}
      >
        <div
          style={{
            margin: "2em auto",
            width: "fit-content",
            display: "block",
            maxWidth: "1000px",
          }}
        >
          <AgentGrid responsiveStatus={responsiveStatus} />
        </div>
      </dv>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
  becomeAgentBG: {
    // minHeight: '100vh',
    textAlign: "center",
    // padding: '0 0 40px 0',
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  becomeAgentBG_M: {
    // minHeight: '100vh',
    textAlign: "center",
    padding: "0px 0px 0px 10px",
    overflow: "hidden",
    backgroundImage: `url(${layout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
};

export default FindAnAgents;
